module.exports = __webpack_public_path__ + "static/media/czech-republic.a759b433.svg";